import React, { FC } from "react";
import { Box, Stack, SxProps } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

interface Props {
  url: string;
  title: string;
}

const YouTube: FC<Props> = ({ url, title }) => {
  const isMobile = useMediaQuery("(max-width:520px)");
  const containerStyles: SxProps = isMobile
    ? {
        position: "relative",
        paddingBottom: "56.25%",
        overflow: "hidden",
        width: "100%",
        height: "auto",
      }
    : {};
  const frameStyles: SxProps = isMobile
    ? {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
      }
    : {};

  return (
    <Stack
      alignItems="flex-start"
      sx={{
        ...containerStyles,
        "& iframe": {
          ...frameStyles,
        },
      }}
    >
      <iframe
        src={url}
        title={title}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        width={isMobile ? "100%" : "520px"}
        height={isMobile ? "auto" : "290px"}
        style={{ borderRadius: "15px" }}
      />
    </Stack>
  );
};

export default YouTube;
